import React, { useState } from 'react';
import { Button, Drawer, List } from 'antd';
import Icon, { CloseOutlined } from '@ant-design/icons';
import Image from 'next/image';
import { useWindowSize } from '@src/components/hooks/useWindowDimensions';
import { NavLink } from '../nav-link/NavLink';
import { WEBSITE_PUBLIC_CDN } from 'util/constants';
import styles from './menu-drawer.module.css';

export const MenuDrawer = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const size = useWindowSize();

  return (
    <div className={styles.wrapper}>
      {visible ? (
        <Button
          className={styles.menuButton}
          icon={<CloseOutlined className={styles.menuIcon} />}
          onClick={() => setVisible(false)}
        ></Button>
      ) : (
        <Button
          className={styles.menuButton}
          icon={
            <Icon
              component={() => (
                <Image
                  src={`${WEBSITE_PUBLIC_CDN}/white-burger-menu.svg`}
                  alt='burger menu'
                  width={24}
                  height={24}
                />
              )}
              className={styles.menuIcon}
              style={{ fontSize: 25 }}
            />
          }
          onClick={() => setVisible(true)}
        ></Button>
      )}
      {(size?.width as number) <= 1000 && (
        <Drawer
          data-cy='mobile-menu'
          placement='bottom'
          onClose={() => {
            setVisible(false);
          }}
          headerStyle={{ display: 'none' }}
          height={'100%'}
          open={visible}
          contentWrapperStyle={{
            width: '60%',
            marginLeft: 'auto',
            marginTop: '80',
          }}
          className={styles.menuDrawer}
        >
          <List
            size='small'
            itemLayout='horizontal'
            className={styles.menuList}
          >
            <List.Item onClick={() => setVisible(false)}>
              <div className={styles.linkWrapper}>
                <NavLink url='/' text='About' />
              </div>
            </List.Item>
            <List.Item onClick={() => setVisible(false)}>
              <div className={styles.linkWrapper}>
                <NavLink url='/agent3d' text='Agent 3D' />
              </div>
            </List.Item>
            <List.Item onClick={() => setVisible(false)}>
              <div className={styles.linkWrapper}>
                <NavLink url='/create-3d' text='Create 3D' />
              </div>
            </List.Item>
            <List.Item onClick={() => setVisible(false)}>
              <div className={styles.linkWrapper}>
                <NavLink url='/gaming' text='Gaming' />
              </div>
            </List.Item>
          </List>
        </Drawer>
      )}
    </div>
  );
};
